import React, { PropTypes } from 'react';
import { Link, IndexLink } from 'react-router';

import 'styles/header.scss';

const Header = (props) => {
    return (
        <header className="section header">
          <div className="container">
            <div className="header-logo">
              <a href="http://www.drkiandra.com">Dr. Kiandra Hebert</a>
            </div>
            <div className="header-nav">
              <ul>
                <li>
                  <a href="https://medium.com/@drkiandra">Blog</a>
                </li>
                <li>
                  <a href="https://www.youtube.com/channel/UCPdZ-BNcBNkcPcohdEJi12A">Videos</a>
                </li>
                <li>
                  <a href="https://www.facebook.com/profile.php?id=100012010306437&sk=events">Events</a>
                </li>
                <li>
                  <a className="button button-contact" href="mailto:drkiandra@gmail.com">Contact</a>
                </li>
              </ul>
            </div>
          </div>
        </header>
    );
};

export default Header;



/** WEBPACK FOOTER **
 ** ./src/components/Header.js
 **/